import React,{Component} from 'react'
import {
    ConfigProvider,Pagination,
} from "antd";
import zhCN from 'antd/es/locale/zh_CN'; 
import Header from '../common/checkHeader.jsx';
import Footer from '../common/checkFooter.jsx';
import {messageTips} from '../../common/service/Tools.jsx';
// import {config} from '../../common/service/http'
import {requestMainUrl,fontNumbers} from '../../common/service/common'
import CountDown from '../../expertonline/components/CountDown'
import OrderPopup from '../../common/orderPopup'
export default class CheckOreder extends Component{
    constructor(){
        super();
        this.state={
            local:zhCN,
            dialogFlag:false,
            TabPaneCurrent:-1,
            minute: 29,
            second: 59,
            tabList:[
                {
                    name:'待付款',
                },{
                    name:'进行中',
                },{
                    name:'已完成',
                },{
                    name:'已关闭',
                }
            ],
            orderList:[],
            orderCurrentPage:1,
            orderPageSize:0,
            orderAllSize:0,
        }
    }
    // 保存到本地并自动点击
    saveAs(data, name) {
        const urlObject = window.URL || window.webkitURL || window;
        const export_blob = new Blob([data]);
        const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        save_link.href = urlObject.createObjectURL(export_blob);
        save_link.download = name;
        save_link.click();
    }
    // 下载含有url的文件
    downloadUrlFile(url, fileName) {
        const url2 = url.replace(/\\/g, '/');
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url2, true);
        xhr.responseType = 'blob';
        //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
        // 为了避免大文件影响用户体验，建议加loading
        xhr.onload = () => {
            if (xhr.status === 200) {
                // 获取文件blob数据并保存
                this.saveAs(xhr.response, fileName);
            }
        };
        xhr.send();
    }
    // 下载报告
    getOrderResultDown=(item)=>{
        var load_down = requestMainUrl+item.result_pdf;
        // var load_down = config.pathConUrl+config.urlMap.getCheckResultPdf+'?serId='+item.ser_id;
        this.downloadUrlFile(load_down,item.result_pdf)
    }
    getTabPane(index){
        this.setState({
            TabPaneCurrent:index,
        })
        var params = {};
        if(index!==-1){
            params ={
                currentPage:1,
                status:index,
            }
        }else{
            params ={
                currentPage:1,
            }
        }
        this.getList(params);
    }
    getOrderChangePage=(current)=>{
        this.setState({
            orderCurrentPage:current
        })
        var params = {};
        if(this.state.TabPaneCurrent!==-1){
            params ={
                currentPage:current,
                status:this.state.TabPaneCurrent,
            }
        }else{
            params ={
                currentPage:current,
            }
        }
        this.getList(params);
    }
    
    //数据列表
    getList(params){   
        React.$http.paperCheckCheckList(params).then(res=>{
            if(res&&res.success){
                res.list.forEach((v,k)=>{
                    v.orderColse = false;
                    if(v&&v.orderTimeM<=30){
                        v.minuteTime = 29-v.orderTimeM;
                        if(v.orderTimeS){
                            v.secondTime = 59-v.orderTimeS;
                        }
                    }
                    if(v.ser_status===1){
                        if(v.minuteTime<0){
                            v.orderColse = true
                        }
                    }
                })
                this.setState({
                    orderList:res&&res.list,
                    orderCurrentPage:res.page&&res.page.currentPage,
                    orderPageSize:res.page&&res.page.pageSize,
                    orderAllSize:res.page&&res.page.allSize,
                })
            }else{
                window.location.href = '/checkpaper.html'
                messageTips(res&&res.message,1)
                return;
            }
        })
    }
    getCancelCheck(item){
        this.setState({
            ser_id:item.ser_id,
            dialogFlag:!this.state.dialogFlag
        })
    }
    getConfirm=()=>{
        var params = {
            serId:this.state.ser_id
        }
        React.$http.paperCheckCancelCheck(params).then(res=>{
            if(res&&res.success){
                let data = this.state.orderList;
                data.forEach((v,k)=>{
                    if(this.state.ser_id === v.ser_id){
                        v.orderColse = !v.orderColse;
                    }
                });                    
                this.setState({
                    orderList:data,
                    dialogFlag:!this.state.dialogFlag
                })
            }else{
                messageTips(res&&res.message,1);
                return
            }
        });
    }
    getCancel=()=>{
        this.setState({
            dialogFlag:!this.state.dialogFlag
        })
    }
    getendorder=(ser_id)=>{
        React.$http.paperCheckCancelCheck({
            serId:ser_id
        }).then(res=>{
            if(res&&res.success){
                let data = this.state.orderList;
                data.forEach((v,k)=>{
                    if(this.state.ser_id === v.ser_id){
                        v.orderColse = !v.orderColse;
                    }
                });                    
                this.setState({
                    orderList:data,
                })
            }
        });
    }
    end(item,index){
        // var arr = this.state.orderList;
        // if(arr.length>0){
            // window.location.reload();
            // if(arr[index].orderTimeM>=30){
            //     if(arr[index].ser_status===1){
            //         arr[index].orderColse = !arr[index].orderColse;
            //         this.setState({
            //             orderList:arr,
            //         });
            //         this.getendorder(item.ser_id);
            //     }
            // }
        // }
    }
    componentDidMount(){
        var params ={
            currentPage:1,
        }
        this.getList(params);
        React.$http.paperCheckStatusList({type:1}).then((res)=>{
            if(res&&res.success){
                this.setState({
                    tabList:res&&res.statusList
                })
            }else{
                messageTips(res&&res.message,1)
                return
            }
        })
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
        // this.setState = ()=> null;
    }
   
    render(){
        const {
            local,
            tabList,
            TabPaneCurrent,
            orderList,
            orderCurrentPage,
            orderPageSize,
            orderAllSize,
            dialogFlag
        } = this.state;
        
        return(
            <div className="containers">
                <Header></Header>
                <div className="mains">
                    <div className="wrapOrder">
                        <div className="orderTable">
                            <div className="titleOrder">我的查重</div>
                            <div className="contentOrder">
                                <div className="Tabs">
                                    <div className={`TabPane ${TabPaneCurrent===-1?'TabPaneCurrent':''}`} onClick={this.getTabPane.bind(this,-1)}>全部订单</div>
                                    {
                                        tabList&&tabList.map((v,k)=>(
                                            <div className={`TabPane ${TabPaneCurrent===v.statusId?'TabPaneCurrent':''}`} key={k} onClick={this.getTabPane.bind(this,v.statusId)}>{v.statusName}</div>
                                        ))
                                    }
                                    <div className="clear"></div>
                                </div>
                                <div className="TabsContent">
                                    {
                                        orderList&&orderList.length>0?(
                                            <div className="orderTitle">
                                                <div className="oitem obld i348">论文标题</div>
                                                <div className="oitem obld i170">查重版本</div>
                                                <div className="oitem obld i190">金额</div>
                                                <div className="oitem obld i200">状态</div>
                                                <div className="oitem obld i254">操作</div>
                                                <div className="clear"></div>
                                            </div>
                                        ):''
                                    }
                                    {
                                        orderList&&orderList.length>0?
                                        (
                                            orderList.map((item,k)=>(
                                                <div className="orderBox" key={k}>
                                                    <div className="oList">
                                                        <div className="oList_title">
                                                            <span className="otitle">订单号：{item.orderNo}</span>
                                                            <span className="otitle">下单时间：{item.orderTime}</span>
                                                        </div>
                                                        <div className="oList_table">
                                                            <div className="oitem opad textleft obor i348">
                                                                {item.title&&item.title.length>40?fontNumbers(item.title,40):item.title}
                                                            </div>
                                                            <div className="oitem opad obor i170 textcenter">{item.goods_name}</div>
                                                            <div className="oitem opad obor i190 textcenter">¥{item.user_cost}</div>
                                                            <div className="oitem opad obor i200 textcenter">
                                                                {
                                                                    item.ser_status===4?'已完成':item.statusName
                                                                }
                                                                <br/>
                                                                <a className="btnorder" href={`/checkpaper.html#/order/detail/${item.ser_status}/${item.ser_id}`}>订单详情</a>
                                                            </div>
                                                            <div className="oitem opad i250 textcenter">
                                                                {
                                                                    item.ser_status===1
                                                                    ?(
                                                                        !item.orderColse?(
                                                                            <div className="monenybox">
                                                                                <span className="order_iem"><i className="icon orderTime"></i>
                                                                                    <CountDown minute={item.minuteTime?item.minuteTime:0} seconds={item.secondTime?item.secondTime:0} end={()=>this.end(item,k)}/>
                                                                                    {/* <CountDown minute={29-item.orderTimeM} seconds={59-item.orderTimeS} end={()=>{window.location.reload()}}/> */}
                                                                                </span>
                                                                                <a className="resetsub" href={`/checkpaper.html#/order/detail/${item.ser_status}/${item.ser_id}`}>立即支付</a>
                                                                                <span className="cancelorder" onClick={this.getCancelCheck.bind(this,item)}>取消查重申请</span>
                                                                            </div>
                                                                        ):'已关闭'
                                                                    ):''
                                                                }
                                                                {item.ser_status===2?<span className="gray">已支付</span>:''}
                                                                {item.ser_status===4||item.ser_status===5?<span className="resetsub" onClick={this.getOrderResultDown.bind(this,item)}>下载报告</span>:''}
                                                                {item.ser_status>=7?<span className="gray"></span>:''}
                                                            </div>
                                                            <div className="clear"></div>
                                                        </div> 
                                                    </div>
                                                </div>
                                            ))
                                        ):(
                                            <div className="noDataStyle">
                                                <div className="no-data"></div>
                                                <span className="noPaper">当前账户没有检测的论文</span>
                                                <a className="btnorder" href="/checkpaper.html#/index">开始检测</a>
                                            </div>
                                        )
                                    }
                                    <div className="wrapPage">
                                        {
                                            orderAllSize>orderPageSize?(
                                                <ConfigProvider locale={local}>
                                                    <Pagination defaultCurrent={orderCurrentPage} total={orderAllSize} pageSize={orderPageSize} onChange={this.getOrderChangePage} />
                                                </ConfigProvider>
                                            ):''
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer></Footer>
                {dialogFlag?<OrderPopup getCancel={this.getCancel} getConfirm={this.getConfirm} />:''}
                {/* <div className="wrapout" style={{display:dialogFlag?'block':'none'}}>
                    <div className="weinner">
                        <div className="whead_top">
                            <i className="icon_hg ico-type1"></i>取消订单
                        </div>
                        <div className="wTcontent">您确定要取消订单吗？</div>
                        <div className="wbtn">
                            <span className="webtn cacel" onClick={(e)=>this.getCancel(e)}>取消</span>
                            <span className="webtn comfir" onClick={(e)=>this.getConfirm(e)}>确定</span>
                        </div>
                    </div>
                </div> */}
            </div>
        )
    }
}
